import { Link } from 'react-router-dom';
import { useState, useRef, useEffect } from 'react';
import { FiMenu, FiX, FiChevronDown } from 'react-icons/fi';
import logo from '../assets/lcepl_logo.png';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [moreDropdownOpen, setMoreDropdownOpen] = useState(false);
  const [mobileMoreOpen, setMobileMoreOpen] = useState(false);
  const dropdownRef = useRef(null);

  const navLinks = [
    { path: "/", label: "Home" },
    { path: "/about-us", label: "About Us" },
    { path: "/projects", label: "Projects" },
    { path: "/careers", label: "Careers" },
    { path: "/csr", label: "CSR" },
    { path: "/gallery", label: "Awards" },
    { path: "/contact-us", label: "Contact Us" },
  ];

  const moreLinks = [
    { path: "/policies", label: "Policies & Annual Return" },
  ];

  // Close desktop dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setMoreDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <header className="bg-white border-b border-grey-200 shadow-sm sticky top-0 z-50 font-sans">
      <div className="max-w-8xl mx-auto px-4">
        <div className="flex justify-between items-center h-20">
          {/* Logo and Company Name */}
          <Link to="/" className="flex items-center shrink-0">
            <img
              src={logo}
              alt="LCEPL Logo"
              className="h-20 w-20 object-contain"
            />
            <div className="leading-tight hidden sm:block">
              <h1 className="text-lg md:text-xl font-semibold text-blue-900 whitespace-nowrap">
                Laxmi Civil Engineering Services Pvt Ltd
              </h1>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex flex-nowrap justify-end gap-x-1 lg:gap-x-2 items-center">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="relative px-2 lg:px-3 py-2 text-sm lg:text-base font-medium text-gray-700 hover:text-blue-800 transition-colors duration-200 group whitespace-nowrap"
              >
                {link.label}
                <span className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-0 h-0.5 bg-blue-800 transition-all duration-300 group-hover:w-2/3"></span>
              </Link>
            ))}

            {/* More Dropdown */}
            <div className="relative" ref={dropdownRef}>
              <button
                onClick={() => setMoreDropdownOpen(!moreDropdownOpen)}
                className="flex items-center gap-1 px-2 lg:px-3 py-2 text-sm lg:text-base font-medium text-gray-700 hover:text-blue-800 transition-colors duration-200 whitespace-nowrap focus:outline-none"
              >
                More
                <FiChevronDown
                  className={`h-4 w-4 transition-transform duration-200 ${
                    moreDropdownOpen ? 'rotate-180' : ''
                  }`}
                />
              </button>

              {moreDropdownOpen && (
                <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg border border-gray-100 py-1 z-50">
                  {moreLinks.map((link) => (
                    <Link
                      key={link.path}
                      to={link.path}
                      onClick={() => setMoreDropdownOpen(false)}
                      className="block px-4 py-2 text-sm font-medium text-gray-700 hover:bg-blue-50 hover:text-blue-800 transition-colors duration-150"
                    >
                      {link.label}
                    </Link>
                  ))}
                </div>
              )}
            </div>
          </nav>

          {/* Mobile Menu Toggle */}
          <button
            className="md:hidden text-gray-700 focus:outline-none"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? (
              <FiX className="h-6 w-6" />
            ) : (
              <FiMenu className="h-6 w-6" />
            )}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-white py-3 px-4 shadow-md rounded-b-lg space-y-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="block py-2 px-3 text-base font-medium text-gray-700 hover:text-blue-800 transition"
                onClick={() => setMobileMenuOpen(false)}
              >
                {link.label}
              </Link>
            ))}

            {/* Mobile More Dropdown */}
            <div>
              <button
                onClick={() => setMobileMoreOpen(!mobileMoreOpen)}
                className="w-full flex justify-between items-center py-2 px-3 text-base font-medium text-gray-700 hover:text-blue-800 transition focus:outline-none"
              >
                More
                <FiChevronDown
                  className={`h-4 w-4 transition-transform duration-200 ${
                    mobileMoreOpen ? 'rotate-180' : ''
                  }`}
                />
              </button>

              {mobileMoreOpen && (
                <div className="pl-4 space-y-1">
                  {moreLinks.map((link) => (
                    <Link
                      key={link.path}
                      to={link.path}
                      className="block py-2 px-3 text-sm font-medium text-gray-600 hover:text-blue-800 transition"
                      onClick={() => {
                        setMobileMenuOpen(false);
                        setMobileMoreOpen(false);
                      }}
                    >
                      {link.label}
                    </Link>
                  ))}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;